// bundle-slider.js - Slider de bundles con descuentos
document.addEventListener('DOMContentLoaded', function() {
  
  var track = document.getElementById('bundleSliderTrack');
  if (!track) return;
  
  var slides = Array.from(track.children);
  var prevButton = document.querySelector('.bundle-slider-prev');
  var nextButton = document.querySelector('.bundle-slider-next');
  var dotsContainer = document.getElementById('bundleSliderDots');
  
  var currentIndex = 0;
  var touchStartX = 0;
  var touchEndX = 0;
  var isDragging = false;
  
  // Crear dots
  slides.forEach(function(_, index) {
    var dot = document.createElement('div');
    dot.classList.add('bundle-slider-dot');
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', function() {
      goToSlide(index);
    });
    dotsContainer.appendChild(dot);
  });
  
  var dots = Array.from(document.querySelectorAll('.bundle-slider-dot'));
  
  function updateSlidePosition() {
    if (slides.length === 0) return;
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
    
    if (prevButton) prevButton.disabled = currentIndex === 0;
    if (nextButton) nextButton.disabled = currentIndex === slides.length - 1;
    
    dots.forEach(function(dot, index) {
      dot.classList.toggle('active', index === currentIndex);
    });
  }
  
  function goToSlide(index) {
    currentIndex = Math.min(Math.max(index, 0), slides.length - 1);
    updateSlidePosition();
  }
  
  // Eventos de botones
  if (prevButton) prevButton.addEventListener('click', () => goToSlide(currentIndex - 1));
  if (nextButton) nextButton.addEventListener('click', () => goToSlide(currentIndex + 1));
  
  // Eventos táctiles
  track.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
    isDragging = true;
    track.style.transition = 'none';
  }, { passive: true });
  
  track.addEventListener('touchmove', function(e) {
    if (!isDragging) return;
    touchEndX = e.changedTouches[0].screenX;
    var diff = touchEndX - touchStartX;
    track.style.transform = `translateX(calc(-${currentIndex * 100}% + ${diff}px))`;
  }, { passive: true });
  
  track.addEventListener('touchend', function(e) {
    if (!isDragging) return;
    
    touchEndX = e.changedTouches[0].screenX;
    var diff = touchEndX - touchStartX;
    
    track.style.transition = 'transform 0.3s ease';
    
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        goToSlide(currentIndex - 1);
      } else {
        goToSlide(currentIndex + 1);
      }
    } else {
      updateSlidePosition();
    }
    
    isDragging = false;
  }, { passive: true });
  
  // ============================================
  // FUNCIONALIDAD DE SELECCIÓN DE BUNDLES
  // ============================================
  var bundleButtons = document.querySelectorAll('.bundle-select-btn');
  var addToCartForm = document.querySelector('product-form form, form[data-type="add-to-cart-form"]');
  
  bundleButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Quitar selección anterior
      bundleButtons.forEach(btn => {
        btn.classList.remove('selected');
        btn.textContent = 'SELECCIONAR';
      });
      
      // Marcar este como seleccionado
      this.classList.add('selected');
      this.textContent = '✓ SELECCIONADO';
      
      // Guardar cantidad seleccionada
      var quantity = this.dataset.quantity;
      var price = this.dataset.price;
      
      console.log(`Bundle seleccionado: ${quantity} unidades - ${price}€`);
      
      // Opcional: actualizar el selector de cantidad del producto principal
      var quantityInput = document.querySelector('[name="quantity"]');
      if (quantityInput) {
        quantityInput.value = quantity;
      }
    });
  });
  
  // Modificar el envío del formulario para usar la cantidad seleccionada
  if (addToCartForm) {
    var originalSubmit = addToCartForm.submit;
    
    addToCartForm.addEventListener('submit', function(event) {
      event.preventDefault();
      
      var selectedButton = document.querySelector('.bundle-select-btn.selected');
      var quantity = selectedButton ? selectedButton.dataset.quantity : 1;
      
      var formData = new FormData(addToCartForm);
      formData.set('quantity', quantity);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  }
  
  // Inicializar
  updateSlidePosition();
  
  window.addEventListener('resize', updateSlidePosition);
  
  console.log('✅ Bundle Slider activado');
});
// ============================================
// ACTUALIZAR BUNDLE SLIDER AL CAMBIAR VARIANTE
// ============================================
function initBundleVariantSync() {
  // Escuchar cambios en los botones de variante
  var variantButtons = document.querySelectorAll('.product-form__input input[type="radio"]');
  
  variantButtons.forEach(function(button) {
    button.addEventListener('change', function() {
      // Esperar a que la variante se actualice en el DOM
      setTimeout(function() {
        // Obtener la nueva imagen de la variante seleccionada
        var selectedVariantImage = document.querySelector('.product__media-item:not([style*="none"]) img');
        
        if (selectedVariantImage) {
          var newSrc = selectedVariantImage.src;
          
          // Actualizar TODAS las imágenes del bundle slider
          var bundleImages = document.querySelectorAll('.bundle-variant-image');
          bundleImages.forEach(function(img) {
            img.src = newSrc;
          });
          
          console.log('🔄 Bundle slider actualizado con nueva imagen');
        }
      }, 300); // Pequeño delay para que Shopify actualice
    });
  });
}

// Llamar a la función después de inicializar
initBundleVariantSync();